import { useEffect, useState } from "react";
import { api } from "./api";
import { useStore } from "../context/StoreContext";

const cache = {};

export function clearMessageTemplateCache() { Object.keys(cache).forEach((k) => delete cache[k]); }

export async function fetchMessageTemplates(storeId = "default") {
  if (!cache[storeId]) {
    cache[storeId] = api.get("/message-templates").then((r) => r.data).catch((e) => { delete cache[storeId]; throw e; });
  }
  return cache[storeId];
}

// Returns { key: template } for the current store once loaded, or null.
export function useMessageTemplates() {
  const { currentStore } = useStore();
  const storeId = currentStore?.id || "default";
  const [map, setMap] = useState(null);
  useEffect(() => {
    setMap(null);
    fetchMessageTemplates(storeId)
      .then((d) => setMap(Object.fromEntries(d.templates.map((t) => [t.key, t]))))
      .catch(() => setMap({}));
  }, [storeId]);
  return map;
}

// Mirrors backend message_templates.render: fill {tokens}, drop label lines whose details are all empty.
export function renderMessage(text, ctx) {
  return (text || "")
    .split("\n")
    .flatMap((raw) => {
      const toks = [...raw.matchAll(/\{(\w+)\}/g)].map((m) => m[1]);
      const line = raw.replace(/\{(\w+)\}/g, (_, k) => (ctx[k] ?? "") + "").trim();
      const allEmpty = toks.length && !toks.some((t) => ctx[t]);
      return allEmpty && (!line || /^[^:]{1,30}:\s*\$?$/.test(line)) ? [] : [line];
    })
    .join("\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}

export const firstName = (name) => (name || "").trim().split(" ")[0] || "there";
